import axios from "axios";
import { path } from "../../path";

function generateRandomUsername(firstName, lastName) {
  const randomNumber = Math.floor(Math.random() * 100); // You can adjust the range of the random number if needed
  const dotOrUnderscore = Math.random() < 0.5 ? "." : "_";

  let usernameOptions = [
    `${firstName}${dotOrUnderscore}${lastName}`,
    `${firstName}${randomNumber}${dotOrUnderscore}`,
    `${firstName}_${lastName}${randomNumber}`,
    `${lastName}${dotOrUnderscore}${firstName}`,
    `${lastName}${randomNumber}${dotOrUnderscore}`,
    `${lastName}_${firstName}${randomNumber}`,
    `${firstName}.${lastName}`,
    `${lastName}.${firstName}`,
  ];

  // Filter out usernames with special characters and adjust length
  usernameOptions = usernameOptions.filter(
    (username) =>
      username.length >= 5 &&
      username.length <= 30 &&
      !/[^a-zA-Z0-9_.]/.test(username)
  );

  const randomIndex = Math.floor(Math.random() * usernameOptions.length);

  // Fallback in case all usernames were filtered out
  if (usernameOptions.length === 0) {
    const fallback = `${firstName}${randomNumber}${lastName}`.slice(0, 30).replace(/[^a-zA-Z0-9_.]/g, "");
    return fallback || `user${Date.now()}`;
  }
  
  return usernameOptions[randomIndex];
}

const searchUsername = async (val) => {
  try {
    const response = await axios.post(`${path}/searchusername`, {
      username: val,
    });
    console.log(response);
    return response.data.user;
  } catch (error) {
    console.log(error);
  }
};

export const getRandomUserName = async (firstname, lastname) => {
  const finalFirstName = firstname? firstname.replace(/\s+/g, "").toLowerCase(): "user";
  const finalLastName = lastname? lastname.replace(/\s+/g, "").toLowerCase(): "ant";

  let user = generateRandomUsername(finalFirstName, finalLastName);
  let res = await searchUsername(user);

  while (res !== null) {
    user = generateRandomUsername(finalFirstName, finalLastName);
    res = await searchUsername(user);
  }
  return user;
};
